<template>
  <div class="advantages-section">
    <div class="section-title">
      <h4>{{ title }}</h4>
    </div>
    <div class="advantages-container">
      <div
          class="advantage-card"
          v-for="(advantage, index) in advantages"
          :key="index"
      >
        <div class="advantage-icon">
          <img :src="advantage.icon" :alt="advantage.title" />
        </div>
        <div class="advantage-title">
          <h5>{{ advantage.title }}</h5>
        </div>
        <div class="advantage-detail">
          <span>{{ advantage.detail }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvantagesSection',
  props: {
    advantages: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ""//Decade - Long Specialization in Warning Light Production.
    }
  }
};
</script>

<style scoped>
.advantages-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
}

.section-title {
  width: 100%;
  margin-bottom: 30px;
}

.advantages-container {
  width: 80%;
  max-width: 1500px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.advantage-card {
  display: grid;
  grid-template-rows: auto auto 1fr;
  align-items: center;
  text-align: center;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 15px; /* 添加水平居中 */
  overflow: hidden;
  display: flex; /* 确保图片在容器内居中 */
  justify-content: center;
  align-items: center;
}

.advantage-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.advantage-detail {
  color: #888;
  text-align: center;
}

.advantage-title {
  margin-bottom: 15px;
}

</style>
